// TODO: We should be able to generalize these internal listeners and simplify code here
// by extracting out common logics
export class DocumentSubscriptionManager {
    nodeListenerMap;
    nodeBakedRulesListenerMap;
    allPcbNodesListeners;
    baseDocumentListeners;
    constructor() {
        this.nodeListenerMap = {};
        this.nodeBakedRulesListenerMap = {};
        this.allPcbNodesListeners = [];
        this.baseDocumentListeners = [];
    }
    subscribe(params) {
        switch (params.target) {
            case "pcbNode":
                return this.subscribeToPcbNode(params.uid, params.callback);
            case "pcbNodeBakedRules":
                return this.subscribeToPcbNodeBakedRules(params.uid, params.callback);
            case "allPcbNodes":
                return this.subscribeToAllPcbNodes(params.callback);
            case "baseDocument":
                return this.subscribeToBaseDocument(params.callback);
        }
    }
    getListeners(params) {
        if (params.target === "pcbNode") {
            return this.getPcbNodeListeners(params.uids);
        }
        else if (params.target === "pcbNodeBakedRules") {
            return this.getPcbNodeBakedRulesListeners(params.uids);
        }
        else if (params.target === "allPcbNodes") {
            return this.allPcbNodesListeners;
        }
        else if (params.target === "baseDocument") {
            return this.baseDocumentListeners;
        }
        return [];
    }
    /**
     * Helper function to notify listeners with a `change`
     */
    notify(change, listeners) {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        listeners.forEach((listener) => listener(change));
    }
    subscribeToPcbNode(uid, callback) {
        const listenersByUid = this.nodeListenerMap[uid] || [];
        listenersByUid.push(callback);
        this.nodeListenerMap[uid] = listenersByUid;
        return () => {
            // Check if the subscriptions are still there, the entry could be removed by
            // the unsubscribe method below, which is called when the node is removed.
            const listenersByUid = this.nodeListenerMap[uid];
            if (listenersByUid) {
                this.nodeListenerMap[uid] = listenersByUid.filter((l) => l !== callback);
            }
        };
    }
    subscribeToPcbNodeBakedRules(uid, callback) {
        const listenersByUid = this.nodeBakedRulesListenerMap[uid] || [];
        listenersByUid.push(callback);
        this.nodeBakedRulesListenerMap[uid] = listenersByUid;
        return () => {
            // Check if the subscriptions are still there, the entry could be removed by
            // the unsubscribe method below, which is called when the node is removed.
            const listenersByUid = this.nodeBakedRulesListenerMap[uid];
            if (listenersByUid) {
                this.nodeBakedRulesListenerMap[uid] = listenersByUid.filter((l) => l !== callback);
            }
        };
    }
    subscribeToAllPcbNodes(callback) {
        this.allPcbNodesListeners.push(callback);
        return () => {
            this.allPcbNodesListeners = this.allPcbNodesListeners.filter((l) => l !== callback);
        };
    }
    subscribeToBaseDocument(callback) {
        this.baseDocumentListeners.push(callback);
        return () => {
            this.baseDocumentListeners = this.baseDocumentListeners.filter((l) => l !== callback);
        };
    }
    getPcbNodeListeners(uids) {
        return uids.flatMap((uid) => this.nodeListenerMap[uid] ?? []);
    }
    getPcbNodeBakedRulesListeners(uids) {
        return uids.flatMap((uid) => this.nodeBakedRulesListenerMap[uid] ?? []);
    }
}
//# sourceMappingURL=DocumentSubscriptionManager.js.map